import React from 'react'
import {connect} from 'react-redux';
import localeMap from 'constants/Locales'

const translations = {
  en:{
    verify_modal_text_1:
      'According to the legislation of the Republic of Kazakhstan, in order to place a bet, you must be identified on our website.',
    verify_modal_text_2:
      'To do this, send a photo of the front and back of the identity card, as well as a selfie with the document.',
    verify_modal_text_3: 'We accept the following documents:',
    verify_modal__sub_text_1: 'RK ID',
    verify_modal__sub_text_2: 'Passport of the Republic of Kazakhstan',
    verify_modal__sub_text_3: 'Residence permit of the Republic of Kazakhstan',
    verify_modal__sub_text_4: 'Document of a foreign citizen',
  },
  ru:{
    verify_modal_text_1:
      'Согласно законодательству Республики Казахстан, для заключения пари необходимо быть идентифицированным на нашем сайте.',
    verify_modal_text_2:
      'Для этого загрузите лицевую и оборотную стороны удостоверения личности, а также селфи с документом.',
    verify_modal_text_3: 'Мы принимаем следующие документы:',
    verify_modal__sub_text_1: 'Удостоверение личности РК',
    verify_modal__sub_text_2: 'Паспорт РК',
    verify_modal__sub_text_3: 'Вид на жительство РК',
    verify_modal__sub_text_4: 'Документ иностранного гражданина',
  },
  kk:{
    verify_modal_text_1:
      'Қазақстан Республикасының заңнамасына сәйкес бәс тігу үшін сіз біздің веб сайтта анықталуыңыз керек.',
    verify_modal_text_2:
      'Ол үшін жеке куәлігіңіздің алдыңғы және артқы жағындағы фотосуретті , сонымен қатар селфиді жүктеңіз.',
    verify_modal_text_3: 'Біз келесі құжаттарды қабылдаймыз:',
    verify_modal__sub_text_1: 'Қазақстан Республикасының жеке куәлігі',
    verify_modal__sub_text_2: 'Қазақстан Республикасының төлқұжаты',
    verify_modal__sub_text_3: 'ҚР да тұруға ықтиярхаты',
    verify_modal__sub_text_4: 'Шетелдік азаматтың құжаты',
  },
  uz:{
    verify_modal_text_1:
      'According to the legislation of the Republic of Kazakhstan, in order to place a bet, you must be identified on our website.',
    verify_modal_text_2:
      'To do this, send a photo of the front and back of the identity card, as well as a selfie with the document.',
    verify_modal_text_3: 'We accept the following documents:',
    verify_modal__sub_text_1: 'RK ID',
    verify_modal__sub_text_2: 'Passport of the Republic of Kazakhstan',
    verify_modal__sub_text_3: 'Residence permit of the Republic of Kazakhstan',
    verify_modal__sub_text_4: 'Document of a foreign citizen',
  },
}

function toggleVerifyModal(show) {
  const modalEl = document.getElementById('verify-modal')
  console.log(`toggleVerifyModal: ` + show)
  if (modalEl) {
    modalEl.style.display = show ? 'flex' : 'none'
  }
}

window.toggleVerifyModal = toggleVerifyModal

// const showRoutes = ['/balance/withdraw', '/balance/recharge', '/']
const hideRoutes = ['/identify']

class VerifyModal extends React.Component {
  handleClose = () => {
    const { protocol, host } = window.location
    const [zone, domain] = host.split('.').reverse()
    window.location.assign(protocol + '//' + domain + '.' + zone + '/identify')
  }

  render() {
    const { languageId } = this.props
    // if (!showRoutes.includes(window.location.pathname)) return null
    if (hideRoutes.includes(window.location.pathname)) return null

    const texts = translations[localeMap[languageId]] || {}

    return (
      <div
        id="verify-modal"
        style={{
          position: 'fixed',
          width: '100vw',
          height: '100vh',
          top: 0,
          right: 0,
          bottom: 0,
          left: 0,
          zIndex: 9999,
          display: 'none',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <div
          style={{
            position: 'absolute',
            width: '100%',
            height: '100%',
            backgroundColor: 'rgba(0,0,0,0.3)',
            zIndex: 1,
          }}
        />
        <div
          style={{
            maxWidth: 400,
            backgroundColor: '#fff',
            padding: 20,
            borderRadius: 10,
            zIndex: 2,
            fontSize: 16,
            marginBottom: 15,
            fontWeight: 'bold',
          }}
        >
          <div
            style={{
              margin: '0 auto',
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 10,
            }}
          >
            <svg width="50px" height="50px" viewBox="0 0 21 21" xmlns="http://www.w3.org/2000/svg">
              <g fill="none" fillRule="evenodd">
                <circle cx="10.5" cy="10.5" r="8" stroke="#A1A1A1" strokeLinecap="round" strokeLinejoin="round" />
                <path d="m10.5 11.5v-5" stroke="#A1A1A1" strokeLinecap="round" strokeLinejoin="round" />
                <circle cx="10.5" cy="14.5" fill="#A1A1A1" r="1" />
              </g>
            </svg>
          </div>
          <div style={{ marginBottom: 15 }}>{texts.verify_modal_text_1}</div>
          <div style={{ marginBottom: 15 }}>{texts.verify_modal_text_2}</div>
          <div style={{ marginBottom: 15 }}>{texts.verify_modal_text_3}</div>

          <ul
            style={{
              margin: '0 auto',
              fontSize: 16,
              width: '80%',
              listStyle: 'unset',
            }}
          >
            <li>{texts.verify_modal__sub_text_1}</li>
            <li>{texts.verify_modal__sub_text_2}</li>
            <li>{texts.verify_modal__sub_text_3}</li>
            <li>{texts.verify_modal__sub_text_4}</li>
          </ul>

          <button
            className="btn"
            onClick={this.handleClose}
            style={{
              width: '100%',
              height: 45,
              backgroundColor: '#025A34',
              color: '#fff',
              fontSize: 18,
              fontWeight: 'normal',
              marginTop: 20,
              border: 'none',
              cursor: 'pointer',
            }}
          >
            OK
          </button>
        </div>
      </div>
    )
  }
}

function select(state) {
  const languageId = state.application.get('languageId');
  return {
    languageId
  }
}
export default connect(select)(VerifyModal)



// WEBPACK FOOTER //
// ./js/shared/components/VerifyModal/VerifyModal.jsx